export default __webpack_public_path__ + "static/media/08_shield-2.7795c132.jpg";